import { getActualMark } from "seneca-common/features/exam-questions/utils";

import QuestionStat from "../../../../../models/QuestionStat";

export function getQuestionMark(questionStat?: QuestionStat) {
  return getActualMark(questionStat);
}

export function getQuestionMarksTotal(questionStat?: QuestionStat) {
  return questionStat?.marksTotal;
}

export function isQuestionFlagged(questionStat?: QuestionStat) {
  return !!questionStat?.flagged;
}

export function getQuestionStudyTime(questionStat?: QuestionStat) {
  return questionStat?.studyTime;
}
